import HeaderAppyShop, {getComponentStaticProps} from '../../components/header/headerAppyShop'
import FooterAppyShop from '../../components/footer/footerAppyShop'
import stylesOrl from '../inspiration/inspiration.module.scss'
import styles from "./catalog.module.scss"
import {useTranslation} from 'next-i18next';
import {GetStaticProps} from 'next';
import React, {useEffect, useState} from 'react'
import {Category, Tag} from '../../interfaces/catalog-interfaces';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations'
import {getCategories, getTags} from '../../services/catalog-services';
import {useRouter} from 'next/router'
import Products from '../../components/catalog/items-list';
import {connect} from 'react-redux';
import {ShopState} from '../../interfaces/store-interfaces';
import Link from 'next/link';
import {config} from '../../config-merchant';
import Meta from '../../components/meta/meta';
import {appyShopConfig} from '../../config';
import {isMobile} from 'react-device-detect';
import _variables from "../../styles/global.module.scss";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowRight, faTimes} from "@fortawesome/free-solid-svg-icons";


function Catalog(props: { categories: Category[], headerProps: any, currentCurrency: string, tags: Tag[] }) {

    const router = useRouter();
    const {t} = useTranslation('common');

    const [activeCategory, switchActiveCategory] = useState<number>(null);
    const [activeSorting, switchActiveSorting] = useState<string>(config.defaultCatalogSorting === undefined ? 'NAMEASC' : config.defaultCatalogSorting);
    const [activeTags, setActiveTags] = useState<number[]>([]);
    const [seeMoreTags, setSeeMoreTags] = useState<boolean>(false);
    const [isFilterContentOpen, setFilterContentOpen] = useState<boolean>(!isMobile);
    const [nbProducts, setNbProducts] = useState<number>(0);
    const [searchQuery, setSearchQuery] = useState<string>(null);
    const [searchQueryTmp, setSearchQueryTmp] = useState<string>("");


    const doesCategoryExist = (pathCategoryId): boolean => {
        return props.categories.some(category => category.categoryId === pathCategoryId)
    }

    const clearSearch = () => {
        setSearchQuery("");
        setSearchQueryTmp("");
        router.push(`/catalog?category=${activeCategory}`)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && searchQueryTmp !== '') {
            router.push(`/catalog?research=${searchQueryTmp}&category=${activeCategory}`)
        }
    }

    useEffect(() => {
        if (router.isReady) {
            if (doesCategoryExist(+router.query.category)) {
                switchActiveCategory(+router.query.category);
            } else {
                switchActiveCategory(0);
            }
            if (router.query.research !== undefined) {
                setSearchQuery("" + router.query.research)
                setSearchQueryTmp("" + router.query.research)
            } else {
                setSearchQuery(undefined);
            }
        }
    }, [router.query])

    return (
        <>
            <Meta
                title={activeCategory !== 0 && activeCategory !== null ?
                    t('NAV_CATALOG') + " - " + props.categories.find(category => category.categoryId === activeCategory).name + " | " + config.merchantShopName
                    : t('NAV_CATALOG')}
                description={t('CATALOG_META_DESC') + props.categories.map(category => category.name).join(', ') + " ..."}
                metaRobots={true}
                image={config.merchantDomain + config.defaultMetaImage}
            />
            <HeaderAppyShop activepage={'catalog'} headerProps={props.headerProps} activeCategory={activeCategory}
                            searchQuery={searchQuery}/>
            <main>

                <div className={styles.catalog}>

                    <div className={styles['layout-row']}>
                        <div className={`${styles['layout-column-left']} ${styles['catalog-filter']}`}>

                            <div className={styles['search-input']}>
                                <input
                                    type="text"
                                    placeholder={t('NAV_SEARCH')}
                                    value={searchQueryTmp}
                                    onChange={(e) => setSearchQueryTmp(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                />

                                <button className={styles['search-button-desk']} hidden={searchQueryTmp === ""}
                                        onClick={() => {
                                            if (searchQueryTmp !== '' && searchQueryTmp !== searchQuery) {
                                                router.push(`/catalog?research=${searchQueryTmp}`)
                                            } else {
                                                clearSearch();
                                            }
                                        }}
                                >
                                    {
                                        searchQueryTmp !== searchQuery ? <FontAwesomeIcon
                                                icon={faArrowRight}
                                                style={{color: _variables.mainColor, height: "20px"}}/> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                style={{color: _variables.mainColor, height: "20px"}}/>
                                    }

                                </button>
                            </div>

                            {
                                isMobile && <div
                                    className={styles['display-hide-catalog-filters']}
                                    onClick={() => setFilterContentOpen(old => !old)}
                                >
                                    <span>{t("CATALOG_FILTER_MOBILE_BUTTON")}</span>
                                </div>
                            }
                            <div
                                className={isFilterContentOpen ? styles['catalog-filters-content-open'] : styles['catalog-filters-content-close']}>

                                <p className={styles['items-title']}>{t('CATALOG_CATEGORIES')}</p>
                                <div
                                    className={`${styles['items-list']} ${styles['catalog-fix-h']} ${styles['scroll']}`}>
                                    <ul className={styles['items']}>
                                        <Link href={`/catalog?research=${searchQueryTmp}`}>
                                            <li className={(activeCategory === 0 && router.query.research === undefined) ? styles['active'] : ''}>{t('CATALOG_ALL')}</li>
                                        </Link>
                                        {props.categories.map((categorie) =>
                                            <Link key={categorie.categoryId}
                                                  href={`/catalog?category=${categorie.categoryId}&research=${searchQueryTmp}`}>
                                                <li className={activeCategory === categorie.categoryId ? styles['active'] : ''}>{categorie.name}</li>
                                            </Link>
                                        )}
                                    </ul>
                                </div>

                                <p className={styles['items-title']}>{t('CATALOG_SORT_BY')}</p>
                                <div className={`${styles['items-list']} ${styles['no-scroll']}`}>
                                    <ul className={styles['items']}>
                                        <li onClick={() => switchActiveSorting('NAMEASC')}
                                            className={activeSorting === 'NAMEASC' ? styles['active'] : ""}>{t('CATALOG_SORT_BY_NAMES')}</li>
                                        <li onClick={() => switchActiveSorting('RELEVANCE')}
                                            className={activeSorting === 'RELEVANCE' ? styles['active'] : ""}>{t('CATALOG_SORT_BY_RELEVANCE')}</li>
                                        <li onClick={() => switchActiveSorting('PRICEASC')}
                                            className={activeSorting === 'PRICEASC' ? styles['active'] : ""}>{t('CATALOG_SORT_BY_ASC')}</li>
                                        <li onClick={() => switchActiveSorting('PRICEDESC')}
                                            className={activeSorting === 'PRICEDESC' ? styles['active'] : ""}>{t('CATALOG_SORT_BY_DESC')}</li>
                                    </ul>
                                </div>

                                {
                                    props.tags.length > 0 && <>
                                        <p className={styles['items-title']}>{t('CATALOG_FILTER_ON')}</p>
                                        <div className={`${styles['filters-list']} ${styles['no-scroll']}`}>
                                            <ul className={styles['filters']}>
                                                {
                                                    props.tags.map((tag, idx) => {
                                                        if (!seeMoreTags && idx > 9) return "";
                                                        if (activeTags.includes(tag.tagId)) {
                                                            return <li
                                                                key={tag.tagId}
                                                                className={styles['active']}
                                                                onClick={() => setActiveTags(old => {
                                                                    const copy = [...old];
                                                                    copy.splice(copy.indexOf(tag.tagId), 1)
                                                                    return copy;
                                                                })}
                                                            >
                                                                {tag.name}
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg" width="10.964"
                                                                    height="10.964"
                                                                    viewBox="0 0 10.964 10.964"
                                                                >
                                                                    <path className={styles['cross-color']}
                                                                          d="M5.769,4.733A.733.733,0,0,0,4.733,5.769L8.964,10,4.733,14.231a.733.733,0,0,0,1.036,1.036L10,11.036l4.231,4.231a.733.733,0,0,0,1.036-1.036L11.036,10l4.231-4.231a.733.733,0,1,0-1.036-1.036L10,8.964Z"
                                                                          transform="translate(-4.518 -4.518)"/>
                                                                </svg>
                                                            </li>
                                                        } else {
                                                            return (
                                                                <li
                                                                    onClick={() => setActiveTags(old => [...old, tag.tagId])}
                                                                    key={tag.tagId}
                                                                >
                                                                    {tag.name}
                                                                </li>
                                                            )
                                                        }
                                                    })
                                                }
                                            </ul>
                                            {
                                                (!seeMoreTags && props.tags.length > 10) &&
                                                <p
                                                    className={styles['see-all']}
                                                    onClick={() => setSeeMoreTags(true)}
                                                >
                                                    {t("CATALOG_FILTER_SEE_MORE")}
                                                </p>
                                            }
                                        </div>
                                    </>
                                }
                            </div>

                        </div>
                        <div className={styles['layout-column-right']}>
                            { activeCategory === 0 && <div className={stylesOrl['catalog']}>
                                <p className={stylesOrl['citation']}>ENTREZ DANS MON UNIVERS</p>

                                <p className={stylesOrl['text']}>
                                    La première collection d’esprits de parfums <span
                                    className={stylesOrl['orel-label']}>Orel</span> se compose de quatre fragrances
                                    enveloppantes. Chaque opus de cette collection a été créé et baptisé en hommage à un
                                    instrument de musique traditionnel malien.
                                </p>
                                <p className={stylesOrl['text']}>
                                    Véritable invitation au voyage, tous matérialisent une présence et incarnent une
                                    personnalité au caractère affirmé. Exigeante et passionnée, Aurélie s’est entourée
                                    des meilleurs du bassin lémanique pour écrire la partition de ses compositions.
                                </p>
                                <p className={stylesOrl['text']}>
                                    <span className={styles['orel-label']}>Orel</span> est la première à métamorphoser
                                    l’héritage de deux continents en parfums confidentiels à la personnalité singulière.
                                </p>
                            </div>}

                            {
                                activeCategory !== 0 && activeCategory !== null &&
                                <>
                                    <div className={styles['products-cover']}>
                                        <div className={styles['text']}>
                                            <p className={styles['title']}>{props.categories.find(category => category.categoryId === activeCategory).name}</p>
                                            <p className={styles['subtitle']}>{props.categories.find(category => category.categoryId === activeCategory).subtitle}</p>
                                        </div>
                                        <div className={styles['cover-overlay']}/>
                                        <img
                                            src={props.categories.find(category => category.categoryId === activeCategory).coverImage}
                                            alt="cover"/>
                                    </div>
                                </>
                            }
                            {(searchQuery !== undefined && searchQuery !== "") &&
                                <div className={styles['research-result']}>
                                    {nbProducts === 0 ?
                                        <>
                                            <p>{t('NAV_SEARCH_NO_RESULT')}</p>
                                            <p>{router.query.research}</p>
                                            <p>{"... ☹"}</p>
                                        </>
                                        : <>
                                            <p>{t('NAV_SEARCH_RESULT').replace("%NBR%", "" + (nbProducts))}</p>
                                            <p>{router.query.research}</p>
                                            <p>{"... "}</p>
                                        </>
                                    }
                                </div>}
                            {(activeCategory !== null && searchQuery !== null) &&
                                <Products
                                    nbProducts={nbProducts}
                                    activeCategory={activeCategory}
                                    activeSorting={activeSorting}
                                    researchQuery={searchQuery}
                                    setNbProducts={setNbProducts}
                                    activeTags={activeTags}
                                    key={activeCategory + activeSorting + props.currentCurrency + searchQuery + activeTags.join()}
                                />
                            }
                        </div>
                    </div>

                </div>
            </main>
            <FooterAppyShop/>
        </>
    )
}

export const getStaticProps: GetStaticProps = async ({locale}) => {
    if (config.menu.some(item => item.path === 'catalog') || config.footerLink.some(item => item.url === '/catalog')) {
        let categories = [];
        try {
            categories = await getCategories(locale.toUpperCase());
            categories = categories['data'];
        } catch (e) {
            console.log(e);
        }
        let tags = [];
        try {
            tags = await getTags(locale.toUpperCase());
            tags = tags['data'].filter(tag => tag.nbProduct > 0);
        } catch (e) {
            console.log(e);
        }
        return {
            props: {
                ...await serverSideTranslations(locale, ['common']),
                categories,
                tags,
                headerProps: await getComponentStaticProps(locale)
            },
            revalidate: appyShopConfig.revalidateData
        }
    } else {
        return {
            notFound: true
        }
    }
}

const mapState = (state: ShopState) => ({
    currentCurrency: state.currentCurrency
})

export default connect(mapState, null)(Catalog)

